import React from "react";
import TopBannerSection from "../components/TopBannerSection";
import PoolImg from "../assets/PoolChair.png";
import FullPoolImg from "../assets/fullWidthPoolChair.png";
import EventWrapper1 from "../components/Decor/EventWrapper1";
import EventWrapper2 from "../components/Decor/EventWrapper2";
import Container from "../components/Container";
const Decor = () => {
  return (
    <Container>
      <TopBannerSection
        Image={PoolImg}
        pageName={"Decor"}
        Quote={"Get A Best Deal"}
      />

      <EventWrapper1 />
      <img
        src={FullPoolImg}
        style={{ maxWidth: "1440px" }}
        width={"100%"}
        alt="fullWidthPoolChair"
      />

      <EventWrapper2 />
    </Container>
  );
};

export default Decor;
